import React from 'react';
import './LeftBigRightSmall.less';

interface LeftBigRightSmallState {

}

interface LeftBigRightSmallPropType {
    prefixCls?: string;
    floorId: any;
    floorTemplate: any[];
    onFloorClick: Function;
}

class LeftBigRightSmall extends React.Component<LeftBigRightSmallPropType, LeftBigRightSmallState> {
    static defaultProps = {
        prefixCls: 'leftBigRightSmall',
    };

    render() {
        const {prefixCls, floorId, floorTemplate, onFloorClick} = this.props;
        return (
            <div className={prefixCls}>
                <div className={`${prefixCls}imgBox leftBox`} onClick={() => {
                    onFloorClick && onFloorClick(floorId, floorTemplate[0].moduleName, floorTemplate[0].moduleUrlType, floorTemplate[0].moduleUrl);
                }}>
                    <img src={floorTemplate[0].moduleImgUrl} alt=""/>
                </div>
                <div className={`${prefixCls}imgBox rightBox`} onClick={() => {
                    onFloorClick && onFloorClick(floorId, floorTemplate[1].moduleName, floorTemplate[1].moduleUrlType, floorTemplate[1].moduleUrl);
                }}>
                    {/* 暂时注释，不可删除 */}
                    <img src={floorTemplate[1].moduleImgUrl} alt=""/>
                </div>
            </div>
        );
    }
}

export default LeftBigRightSmall;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/floorModule/leftBigRightSmall/LeftBigRightSmall.tsx